import { gql } from "@apollo/client";

export const AssetTelemetryAttributes = gql`
    query AssetTelemetryAttributes($id: ID!) {
        assetLocation(id: $id) {
            id
            asset {
                id
                serialNumber
            }
            iotConnection {
                id
                connectionStatus
            }
            telemetryAttributeList {
                total
                attributes {
                    id
                    alias
                    name
                    description
                    current {
                        value
                        unit {
                            name
                            symbol
                        }
                    }
                }
            }
        }
    }
`;
